"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#014965",
    d: "M23.5,11.92H6.71l4.14-4.15a.5.5,0,0,0,0-.71.5.5,0,0,0-.7,0l-5,5a.5.5,0,0,0,0,.71l5,5a.48.48,0,0,0,.7,0,.5.5,0,0,0,0-.71L6.71,12.92H23.5a.5.5,0,0,0,.5-.5A.5.5,0,0,0,23.5,11.92Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#014965",
    d: "M9.12,13.92l2.44,2.44a1.49,1.49,0,0,1,0,2.12,1.55,1.55,0,0,1-2.12,0l-5-5a1.49,1.49,0,0,1,0-2.12l5-5a1.54,1.54,0,0,1,2.12,0,1.51,1.51,0,0,1,0,2.14L9.12,10.92H14V1.42a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.5.5v21a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-8.5Z"
  }));
};

exports["default"] = _default;